module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Hidden field":"Hidden field"},"de":{"Hidden field":"Verstecktes Feld"}}')
  delete Component.options._Ctor
}
